<ng-container *transloco="let t">
  <div class="analysis-points" [formGroup]="form">
    <div class="grid-cols">
      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Specific gravity') }}</mat-label>
        <input matInput formControlName="specificGravity" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Nitrites') }}</mat-label>
        <input matInput formControlName="nitrites" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Ph') }}</mat-label>
        <input matInput formControlName="ph" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Proteins') }}</mat-label>
        <input matInput formControlName="proteins" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Glucose') }}</mat-label>
        <input matInput formControlName="glucose" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Urobilinogen') }}</mat-label>
        <input matInput formControlName="urobilinogen" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Bilirubin') }}</mat-label>
        <input matInput formControlName="bilirubin" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Ketones') }}</mat-label>
        <input matInput formControlName="ketones" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Leukocytes') }}</mat-label>
        <input matInput formControlName="leukocytes" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Blood (erythrocytes)') }}</mat-label>
        <input matInput formControlName="bloodErythrocytes" />
      </mat-form-field>
    </div>

    <h3 class="mt-3 mb-1">{{ t('SEDIMENT') }}</h3>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ t('Sediment') }}</mat-label>
      <textarea matInput formControlName="sediment" rows="6"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
